import * as React from 'react';
import {
    DialogFooter, Button, ButtonType, Label
} from 'office-ui-fabric-react';

interface IProps {
    timeoutPassed: boolean;
    closeDialog: () => void;
}

export class AuthenticationWarning extends React.Component<IProps, any> {

    render() {

        let { timeoutPassed, closeDialog } = this.props;

        let message: string = timeoutPassed ? 'Your session has expired. Please click OK to log out.' : 'Your session will expire soon and you will be logged out. Please click OK to continue your session.';

        return (
            <div className="authentication-warning">
                <i className="ms-Icon ms-Icon--Warning timeout-warning-icon" aria-hidden="true"></i>
                <Label>{message}</Label>
                <DialogFooter>
                    <Button tabIndex={1002} buttonType={ ButtonType.primary } onClick={ () => closeDialog() }>OK</Button>
                </DialogFooter>
            </div>
        );

    }

}


// WEBPACK FOOTER //
// ./source/ts/components/authentication/authentication-warning.tsx